'use client';

import type { ICollectionPipelineStatusV3 } from '@repo/sdk';
import { translateCollectionApi } from '@repo/sdk';
import type { JSX } from 'react';
import { useCallback } from 'react';
import { PipelineStepBadge } from '../pipeline-step-badge';
import { PipelineStepCell } from '../pipeline-step-cell';
import { PipelineStepDialog } from '../pipeline-step-dialog';
import { useStepAction } from '../use-step-action';
import { StepLogPanel } from './step-log-panel';

interface ITranslateStepProps {
  item: ICollectionPipelineStatusV3;
}

function resolveDisabled(item: ICollectionPipelineStatusV3): string | undefined {
  if (item.steps.populated.done === 0) {
    return 'Nothing populated yet';
  }
  return undefined;
}

export function TranslateStep({ item }: ITranslateStepProps): JSX.Element {
  const { translated } = item.steps;
  const collectionId = item.collectionId;
  const start = useCallback(() => translateCollectionApi({ collectionId }), [collectionId]);
  const action = useStepAction({ start });
  const disabled = resolveDisabled(item);

  return (
    <PipelineStepCell
      badge={<PipelineStepBadge step={translated} />}
      renderDialog={(open, onOpenChange) => (
        <PipelineStepDialog
          open={open}
          onOpenChange={onOpenChange}
          title="Translate"
          description={`Translate every populated challenge into the configured target languages. ${translated.done}/${translated.total} translated.`}
          dataHref={`/sys/challenges?collectionId=${item.collectionId}`}
          dataLabel="Open challenges"
          primaryAction={{
            label: 'Run translate',
            onClick: action.run,
            pending: action.status === 'running',
            disabledReason: disabled,
          }}
          body={<StepLogPanel status={action.status} log={action.log} />}
        />
      )}
    />
  );
}
